import { render, staticRenderFns } from "./NonConformityOriginSelect.vue?vue&type=template&id=089fcd7a&scoped=true&"
import script from "./NonConformityOriginSelect.vue?vue&type=script&lang=js&"
export * from "./NonConformityOriginSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089fcd7a",
  null
  
)

export default component.exports